import React, { useState } from 'react';
import { getResetPasswordError } from '../../common/functions/get.api.error.message';
import translate from '../../common/functions/translate';
import useForgotPasswordApi from '../../common/hooks/use.forgot.password.api';
import ForgotPassword from '../../forgot-password/components/forgot.password';
import ForgotUsername from '../../forgot-username/components/forgot.username';

export default function ForgotUsernameAndPassword() {
   const [step, setStep] = useState(0);
   const [forgotUsernameData, setForgotUsernameData] = useState({});
   const [secretQuestion, setSecretQuestion] = useState('');
   const [error, setError] = useState('');
   const [isLoading, setIsLoading] = useState(false);
   const forgotPasswordApi = useForgotPasswordApi();
   
   const next = () => setStep(current => current + 1);
   const prev = () => setStep(current => current - 1);

   const getSecretQuestion = async () => {
      if (isLoading) {
         return;
      }
      setIsLoading(true);
   
      const {medicareNumber, lastName, suffix, username, dateOfBirth} = forgotUsernameData;
   
      try {
         const question = await forgotPasswordApi.getSecretQuestion({
            mbi: medicareNumber,
            username,
            lastName,
            suffix,
            dateOfBirth
         });
         setError('');
         setSecretQuestion(question);
         next();
      } catch (e) {
         let errorMessage;
         if (e.code) {
            errorMessage = getResetPasswordError(e.code, e.errors)['applicationErrorMessage'];
         } else {
            errorMessage = `${translate('Error')}: ${translate("We can't process your request at this time. We're sorry for any inconvenience. Please try again.")}`;
         }
         setError(errorMessage);
      } finally {
         setIsLoading(false);
      }
   };

   const steps = [
      <ForgotUsername
         titleText={translate('Forgot username and password')}
         subTitle={translate('Get your username and reset your password.')}
         buttonText={translate('Next')}
         combinedWithPassword
         onData={setForgotUsernameData}
         initData={forgotUsernameData}
         onNextClick={getSecretQuestion}
         onNextLoading={isLoading}
         getSecretQuestionErrorMessage={error}
      />,
      <ForgotPassword
         combinedWithUsername
         secretQuestion={secretQuestion}
         onBackClick={prev}
         forgotUsernameData={forgotUsernameData}
      />
   ]

   return steps[step];
}